import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { AUTH } from '../constants/testIds';
import { GoogleLoginButton } from '../components/GoogleAuth';

const inputCls =
  'w-full rounded-lg bg-white/[0.04] border border-white/15 px-4 py-3 text-white placeholder-[#5c6a7a] text-sm focus:outline-none focus:border-[#c6f24e] transition-colors';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      navigate('/start-here');
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: '#07090c' }}>
      <div aria-hidden="true" className="pointer-events-none fixed inset-0"
        style={{ background: 'radial-gradient(ellipse 60% 40% at 50% -10%, rgba(198,242,78,0.08), transparent 70%)' }} />
      <div className="relative w-full max-w-md py-12">
        <div className="text-center mb-8">
          <Link to="/">
            <img src="/gritclicks-logo.png" alt="GritClicks" className="h-20 w-auto mx-auto mb-4" data-testid="login-logo" />
          </Link>
          <p className="text-[11px] font-bold tracking-[0.35em] uppercase" style={{ color: '#c6f24e' }}>Member Login</p>
        </div>

        <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-8" data-testid={AUTH.loginForm}>
          <h2 className="text-2xl font-extrabold text-white mb-6">Sign In</h2>

          {error && (
            <div className="border px-4 py-3 rounded-lg mb-4 text-sm font-semibold"
              style={{ borderColor: 'rgba(248,113,113,0.4)', backgroundColor: 'rgba(248,113,113,0.08)', color: '#f87171' }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm text-[#c9d3de] mb-2">Email</label>
              <input
                data-testid={AUTH.loginEmail}
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={inputCls}
                placeholder="you@company.com"
                required
              />
            </div>

            <div>
              <label className="block text-sm text-[#c9d3de] mb-2">Password</label>
              <input
                data-testid={AUTH.loginPassword}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={inputCls}
                placeholder="••••••••"
                required
              />
            </div>

            <button
              data-testid={AUTH.loginSubmit}
              type="submit"
              disabled={loading}
              className="w-full rounded-lg py-3.5 font-extrabold text-[15px] tracking-wide transition-colors disabled:opacity-50"
              style={{ backgroundColor: '#c6f24e', color: '#07090c' }}
            >
              {loading ? 'Signing in…' : 'SIGN IN'}
            </button>
          </form>

          <div className="flex items-center gap-3 my-5">
            <div className="flex-1 h-px bg-white/10" />
            <span className="text-xs text-[#5c6a7a] uppercase">or</span>
            <div className="flex-1 h-px bg-white/10" />
          </div>
          <GoogleLoginButton label="Continue with Google" />

          <p className="mt-6 text-center text-sm text-[#8494a5]">
            Don't have an account?{' '}
            <Link to="/register" className="font-semibold hover:underline" style={{ color: '#c6f24e' }}>
              Sign Up
            </Link>
          </p>
        </div>

        <p className="text-center mt-6">
          <Link to="/" className="text-[12px] text-[#5c6a7a] hover:text-[#c9d3de] transition-colors" data-testid="login-back-link">
            ← Back to gritclicks.com
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
